module.exports = __webpack_public_path__ + "static/o_nama_2005-f287119a3cec49d8da2329f736c2df23.png";